export function updateLastInRow() {
  const containers = document.querySelectorAll('.animate-tabs__btns')
  containers.forEach((container) => {
    const items = Array.from(container.children)
    let lastTop = null

    items.forEach(item => item.classList.remove('last-in-row'))
    items.forEach((item, index) => {
      const itemRect = item.getBoundingClientRect()

      if (index === 0) {
        lastTop = itemRect.top
      }

      if (itemRect.top > lastTop) {
        items[index - 1].classList.add('last-in-row')
        lastTop = itemRect.top
      }

      if (index === items.length - 1) {
        item.classList.add('last-in-row')
      }
    })
  })
}
window.addEventListener('DOMContentLoaded', () => {
  window.addEventListener('load', updateLastInRow)
  window.addEventListener('resize', () => {
    requestAnimationFrame(updateLastInRow)
  })

})
